import React,{useState} from 'react';
import {Storage} from "aws-amplify";
import {TextField,
    Button
  } from '@material-ui/core'

/***
 * Sorts the json by multiple JSON keys: https://github.com/Teun/thenBy.js/blob/master/thenBy.js
   Copyright 2013 Teun Duynstee
   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at
     http://www.apache.org/licenses/LICENSE-2.0
   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/
var firstBy = (function() {

  function identity(v){return v;}

  function ignoreCase(v){return typeof(v)==="string" ? v.toLowerCase() : v;}

  function makeCompareFunction(f, opt){
      opt = typeof(opt)==="object" ? opt : {direction:opt};
      
      if(typeof(f)!="function"){
          var prop = f;
          // make unary function
          f = function(v1){return !!v1[prop] ? v1[prop] : "";}
      }
      if(f.length === 1) {
          // f is a unary function mapping a single item to its sort score
          var uf = f;
          var preprocess = opt.ignoreCase?ignoreCase:identity;
          var cmp = opt.cmp || function(v1,v2) {return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;}
          f = function(v1,v2) {return cmp(preprocess(uf(v1)), preprocess(uf(v2)));}
      }
      const descTokens = {"-1":'', desc:''};
      if(opt.direction in descTokens) return function(v1,v2){return -f(v1,v2)};
      return f;
  }

  /* adds a secondary compare function to the target function (`this` context)
     which is applied in case the first one returns 0 (equal)
     returns a new compare function, which has a `thenBy` method as well */
  function tb(func, opt) {
      /* should get value false for the first call. This can be done by calling the 
      exported function, or the firstBy property on it (for es6 module compatibility)
      */
      var x = (typeof(this) == "function" && !this.firstBy) ? this : false;
      var y = makeCompareFunction(func, opt);
      var f = x ? function(a, b) {
                      return x(a,b) || y(a,b);
                  }
                : y;
      f.thenBy = tb;
      return f;
  }
  tb.firstBy = tb;
  return tb;
})();

const Upload = (props)=>{
  const [processList, 
    setProcessList] = useState('');
  const handleProcessListChange =(e) =>{
    setProcessList(e.target.value)
  }
  const handleProcessList =async()=>{
    //trim the unnecessary lead and trailing stuff
    try {
    let process_list = processList
    if (process_list.substring(0,4)==='JSON'){
      process_list = process_list.substring(4)
    }
    process_list = '['+process_list.replace(/[\n\r]+/g, '').slice(0,-1)+']'
    //Create an array
    let parsed_process_list = JSON.parse(process_list)


    parsed_process_list = parsed_process_list.sort(
      firstBy("user_name")
      .thenBy("descrip")
      .thenBy("fascia")
  );
    
    
    //lets sort the parsed list by fascia, brand, description
    // take a download of all fascia's, needed for exhibitors
    await Storage.put('show-data/Fascia-ALL.json',JSON.stringify(parsed_process_list))

    //Now sort by descrip and compile the array into fascia groups and then upload them to S3
    let result = parsed_process_list
    .reduce( (r, a)=> {
      r[a.fascia] = r[a.fascia] || [];
      r[a.fascia].push(a);
      return r;
  }, Object.create(null));
  //Now loop through the fascia array and upload the json files for each fascia to S3
  let fascias = []
  for (const [key] of Object.entries(result)) {
    fascias.push(key)
  }
  Storage.configure({
      Storage: {
          AWSS3: {
              bucket: 'bookerattendee153926-dev', //REQUIRED -  Amazon S3 bucket
              region: 'eu-west-1', //OPTIONAL -  Amazon service region
          }
      }
  }
  )
  //let test = await Storage.put('show-data/Fascia_test.json',JSON.stringify(result['P']))

   await Promise.all(fascias.map(
     async(fascia) => {
        //get the file and sort it (this is sorted after upload)
        let output_file = result[fascia]
        /*
        .sort((a, b) => {
          if (a.descrip.toUpperCase() < b.descrip.toUpperCase()) {
              return -1;
          }
          if (a.descrip.toUpperCase() > b.descrip.toUpperCase()) {
              return 1;
          }
          return 0;
        })
        */
        await Storage.put('show-data/Fascia-'+fascia+'.json',JSON.stringify(output_file))
    }));
    alert('Finished Uploading') 


    } catch (e){
      alert ('error parsing:'+e)
    }
    

  }

    return (
        <div>
            <TextField
              id='json_paste'
              placeholder="Copy Price List JSON from Sheet Here (Including the column heading 'JSON')"
              multiline
              fullWidth
              rows={30}
              rowsMax={30}
              value={processList}
              onChange={handleProcessListChange}
            />
            <Button 
            variant="contained"
            onClick={()=>handleProcessList()}
            >Process List</Button>
        </div>
    )
}
export default Upload